export default "__VITE_ASSET__DkS7h7mq__"